import { createSelector, createFeatureSelector } from "@ngrx/store";
import { ThanksYouState } from "./thank-you.state";

export const appThankYouStateSelector = createFeatureSelector<ThanksYouState>("thankYou");

export const appThankYouSelector = createSelector(appThankYouStateSelector, (state) => state);
